import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_GATEWAY_URL } from "../constants/constants";
import VerticalRegistry from "../constants/verticalRegistry";

export const searchUser = async ({ vertical, searchParams }) => {
 
  const verticalInfo = VerticalRegistry.getVerticalByName(vertical);

  const headers = {
    accept: "application/json",
    platform: "web",
    "product-id": verticalInfo?.productId || "300",
    "tenant-id": verticalInfo?.tenantId || "1",
  };

  const endpoint = `${REACT_APP_GATEWAY_URL}/api/v2/unified/search-user`;

  const payload = {
    phone: searchParams.phone || undefined,
    uam_id: parseInt(searchParams.uam_id) || undefined,
    admission_number: searchParams.admission_number || undefined,
  }

  const options = {
    method: "POST",
    headers,
    body: payload,
  };

  return await fetchJSON(endpoint, options);
};

export const useSearchUser = () => {
  return useMutation({
    mutationFn: searchUser,
  });
};
